import { createFileRoute } from "@tanstack/react-router";
import { BookingRulesCard } from "../components/settings/booking-rules/BookingRulesCard";

export const Route = createFileRoute("/_auth/settings/booking-rules")({
  staticData: {
    titleKey: "settings.section.bookingRules",
    breadcrumbKey: "breadcrumb.manage",
    breadcrumbN: 2,
  },
  component: BookingRulesCard,
});
